import { createNullableContext } from '~/common/contexts/nullableContext';
import { MiddleOfficeConfigContextType } from './types/MiddleOfficeConfigContextType';

export const MiddleOfficeConfigContext =
  createNullableContext<MiddleOfficeConfigContextType>();
